const DEFAULT_USER = '0079340';

export {
  DEFAULT_USER
};



// WEBPACK FOOTER //
// ./client/app/common/mocks/authentication.js